import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _defineProperty2 from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _toConsumableArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './Filters.css';
import React, { useEffect, useState } from 'react';
import { canUseDOM, get, getDictionaryItem, replaceUrlPluses } from '../../utils';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { qsToObject } from '../../utils/querystring';
import { useHistory, useLocation } from 'react-router-dom';
import FiltersMobileSwitchPanel from './components/FiltersMobileSwitchPanel/FiltersMobileSwitchPanel';
import DropDownMultiselect from './components/DropDownMultiselect/DropDownMultiselect';
import Sorting from './components/Sorting';
import FiltersSelected from './components/FiltersSelected/FiltersSelected';
import { convertToAnalyticObject } from '../../utils/analytics';
import { commonStyles as headerStyle } from '../57_HeaderListingPage/HeaderListingPage';
import RestaurantsListingSearch from './components/RestaurantsListingSearch/RestaurantsListingSearch';
import DropDown from './components/DropDown/DropDown';
var stateTofacetsObj = function stateTofacetsObj(filterState) {
  return Object.keys(filterState).reduce(function (acc, item) {
    var currentFacetName = filterState[item].facetName;
    var currentValues = filterState[item].value;
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty2({}, currentFacetName, acc[currentFacetName] ? [].concat(_toConsumableArray(acc[currentFacetName]), _toConsumableArray(currentValues)) : currentValues));
  }, {});
};
var Filter = function Filter(_ref) {
  var fields = _ref.fields,
    params = _ref.params,
    setpage = _ref.setpage,
    setHits = _ref.setHits,
    facets = _ref.facets,
    applySetFilters = _ref.applySetFilters,
    rtl = _ref.rtl,
    searchTextValue = _ref.searchTextValue,
    setSearchTextValue = _ref.setSearchTextValue,
    sortingValue = _ref.sortingValue,
    setSortingValue = _ref.setSortingValue,
    nbHits = _ref.nbHits,
    _ref$withMapModalView = _ref.withMapModalView,
    withMapModalView = _ref$withMapModalView === void 0 ? false : _ref$withMapModalView,
    filterState = _ref.filterState,
    setFilterState = _ref.setFilterState;
  var location = useLocation();
  var history = useHistory();
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    filtersCount = _useState2[0],
    setFiltersCount = _useState2[1];
  var queryParams = canUseDOM ? qsToObject(location.search) : {};
  var eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  var dictionary = get(fields, 'data.dictionary');
  var sortField = get(fields, 'data.listingConfiguration.sorting.sortPrefixes') || [];
  var filterData = get(fields, 'data.listingConfiguration.filters') || {};
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    filtersMobileItemsVisible = _useState4[0],
    setFiltersMobileItemsVisible = _useState4[1];
  // const [filterState, setFilterState] = useState(() => createFilterState(filterData.values, location));
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    filterFiledOpened = _useState6[0],
    setFilterFiledOpened = _useState6[1];

  /* Dictionary terms */
  var clearAllText = getDictionaryItem(dictionary, 'ClearAll') || '';
  var clearText = getDictionaryItem(dictionary, 'Clear') || '';
  var filtersTitleText = getDictionaryItem(dictionary, 'FiltersLabel') || '';
  var autocompletePlaceholderText = getDictionaryItem(dictionary, 'SearchFilterPlaceholder') || '';
  var filtersMobileLabelText = getDictionaryItem(dictionary, 'Filters') || '';
  var filtersMobileLabelPanelText = getDictionaryItem(dictionary, 'filterPanelLabel') || '';
  var showResultsText = getDictionaryItem(dictionary, 'ShowResults') || '';
  var sortFieldDeskLabelText = "".concat(getDictionaryItem(dictionary, 'SortLabel')).concat(getDictionaryItem(dictionary, 'DefaultFilter')) || '';
  var sortFieldMobileLabelText = getDictionaryItem(dictionary, 'Sorting') || '';
  var pleaseSelectText = getDictionaryItem(dictionary, 'PleaseSelect') || '';
  var filteredResultsText = getDictionaryItem(dictionary, 'FilteredResultsText') || '';
  useEffect(function () {
    var count = 0;
    var _loop = function _loop(key) {
      var isFullFalseObj = function isFullFalseObj() {
        var isFullFalseObj = true;
        if (filterState[key].value !== null) {
          Object.values(filterState[key].value).forEach(function (el) {
            if (el) {
              isFullFalseObj = false;
            }
          });
        }
        return isFullFalseObj;
      };
      if (typeof filterState[key].value === 'string' ? filterState[key].value !== null : !isFullFalseObj()) {
        count = count + 1;
      }
    };
    for (var key in filterState) {
      _loop(key);
    }
    setFiltersCount(count);
  }, [filterState]);
  var getFilteredResultText = function getFilteredResultText(filteredResultsText, nbHits, searchTextValue) {
    var values = [nbHits, searchTextValue];
    values.forEach(function (value, index) {
      if (index === values.length - 1) {
        filteredResultsText = filteredResultsText.replace(new RegExp("\\{".concat(index, "\\}"), 'g'), "<strong>".concat(value, "</strong>"));
        return;
      }
      filteredResultsText = filteredResultsText.replace(new RegExp("\\{".concat(index, "\\}"), 'g'), value);
    });
    return filteredResultsText;
  };
  if (Object.keys(queryParams).length !== 0) {
    for (var key in queryParams) {
      queryParams[key] = replaceUrlPluses(queryParams[key], key === 'tags' || key === 'itineraryDatesRange') || queryParams[key];
    }
  }
  var filterSelectedAnalyticsClick = function filterSelectedAnalyticsClick(text) {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['FilterClickAnalytics'], params), text);
  };
  var cuisineAnalyticsButtonClick = function cuisineAnalyticsButtonClick(fieldName, newValue) {
    var currentFiled = "".concat(fieldName, ": ").concat(get(newValue, 'value', []).join(', '));
    var otherFields = Object.keys(filterState).filter(function (el) {
      return el !== fieldName;
    }).reduce(function (acc, currentFilterKey) {
      if (filterState[currentFilterKey].value.length) {
        acc += "".concat(currentFilterKey, ": ").concat(filterState[currentFilterKey].value.join(', '));
      }
      return acc;
    }, '');
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['applyFilterAnalytics'], params), "".concat(showResultsText, ":").concat(currentFiled).concat(otherFields ? ': ' : '').concat(otherFields));
  };
  var removeFilterAnalyticsClick = function removeFilterAnalyticsClick(text) {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['removeFilterAnalytics'], params), text);
  };
  var setListingFilter = function setListingFilter() {
    setpage(0);
    setHits([]);
    applySetFilters(true);
  };
  var resetAndSubmitFilters = function resetAndSubmitFilters() {
    var newState = _objectSpread({}, filterState);
    Object.keys(newState).forEach(function (filterName) {
      newState[filterName].value = [];
    });
    var finalQSObject = stateTofacetsObj(newState);
    var url = new URL(window.location.href);
    Object.keys(finalQSObject).forEach(function (facet) {
      url.searchParams.delete(facet);
    });
    history.replace("".concat(history.location.pathname).concat(url.search).concat(url.hash));
    setFilterState(newState);
    setListingFilter();
    removeFilterAnalyticsClick(filtersMobileLabelText);
  };
  var toggleMapButton = function toggleMapButton() {
    var hide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (canUseDOM) {
      var button = document.querySelector('#interactive-map-toggle');
      if (button) {
        button.style.zIndex = hide ? '1' : '2';
      }
    }
  };
  var togglePanelHandler = function togglePanelHandler(close) {
    setFiltersMobileItemsVisible(close === false ? close : !filtersMobileItemsVisible);
    if (close !== false && document.body.style.overflowY === '') {
      document.body.style.overflowY = 'hidden';
      toggleMapButton(true);
    } else {
      document.body.style.overflowY = '';
      toggleMapButton(false);
    }
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "row ".concat(withMapModalView ? 'rest-map-view' : '', " ")
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-xl-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filters"
  }, !withMapModalView ? /*#__PURE__*/React.createElement("div", {
    className: "filters__search"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-lg-10 col-xl-11"
  }, /*#__PURE__*/React.createElement(RestaurantsListingSearch, {
    rtl: rtl,
    searchValue: searchTextValue,
    setSearchValue: setSearchTextValue,
    placeholder: autocompletePlaceholderText,
    setListingFilter: setListingFilter,
    eventsAnalytics: eventsAnalytics,
    params: params
  })))) : null, /*#__PURE__*/React.createElement("h5", {
    className: "filters__header"
  }, filtersTitleText), /*#__PURE__*/React.createElement("div", {
    className: "filters__grid ".concat(withMapModalView ? 'imfilters-padding' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(withMapModalView ? 'col-xl-12' : 'col-6 col-lg-9 col-xl-10')
  }, /*#__PURE__*/React.createElement(FiltersMobileSwitchPanel, {
    filterState: filterState,
    emptyFilterState: "",
    labelText: filtersMobileLabelText,
    filterPanelLabel: filtersMobileLabelPanelText,
    clearAll: clearAllText,
    ctaText: showResultsText,
    togglePanel: togglePanelHandler,
    panelVisible: filtersMobileItemsVisible,
    clearFilter: function clearFilter() {
      togglePanelHandler();
      resetAndSubmitFilters();
    },
    triggerFilterFieldOpen: setFilterFiledOpened,
    pleaseSelectText: pleaseSelectText,
    withMapModalView: withMapModalView,
    filtersCount: filtersCount
  }), /*#__PURE__*/React.createElement("div", {
    className: "filters__desk-layout-wrapper"
  }, !!(filterData.values && filterData.values.length) && /*#__PURE__*/React.createElement("div", {
    className: "filters__desk-layout"
  }, filterData.values.map(function (singleFilter) {
    var filterTemplate = get(singleFilter, 'fieldTypeItem.item.fieldType.value');
    var facetName = get(singleFilter, 'fieldNameItem.item.fieldName.value');
    if (filterTemplate === 'Dropdown') {
      var fieldName = get(singleFilter, 'name');
      return /*#__PURE__*/React.createElement("div", {
        className: "filters__desk-item",
        key: "".concat(withMapModalView ? "map-view-".concat(fieldName) : "".concat(fieldName))
      }, /*#__PURE__*/React.createElement(DropDown, {
        filter: singleFilter,
        algoliaResponcedFacetValues: facets[facetName],
        closeMobileOpener: function closeMobileOpener() {
          return togglePanelHandler(false);
        },
        setValue: function setValue(newValue) {
          setFilterState(_objectSpread(_objectSpread({}, filterState), {}, _defineProperty2({}, fieldName, _objectSpread(_objectSpread({}, filterState[fieldName]), newValue))));
        },
        value: filterState[fieldName] === undefined ? [] : filterState[fieldName].value,
        clearText: clearText,
        ctaText: showResultsText,
        setListingFilter: setListingFilter,
        externalVisible: filterFiledOpened,
        setExternalVisible: setFilterFiledOpened,
        analyticCheckboxCallback: filterSelectedAnalyticsClick,
        analyticButtonCallback: cuisineAnalyticsButtonClick,
        withMapModalView: withMapModalView
      }));
    }
    if (filterTemplate === 'Dropdown Multi Select') {
      var _fieldName = get(singleFilter, 'name');
      return /*#__PURE__*/React.createElement("div", {
        className: "filters__desk-item",
        key: "".concat(withMapModalView ? "map-view-".concat(_fieldName) : "".concat(_fieldName))
      }, /*#__PURE__*/React.createElement(DropDownMultiselect, {
        filter: singleFilter,
        algoliaResponcedFacetValues: facets[facetName],
        closeMobileOpener: function closeMobileOpener() {
          return togglePanelHandler(false);
        },
        setValue: function setValue(newValue) {
          setFilterState(_objectSpread(_objectSpread({}, filterState), {}, _defineProperty2({}, _fieldName, _objectSpread(_objectSpread({}, filterState[_fieldName]), newValue))));
        },
        value: filterState[_fieldName] === undefined ? [] : filterState[_fieldName].value,
        clearText: clearText,
        ctaText: showResultsText,
        setListingFilter: setListingFilter,
        externalVisible: filterFiledOpened,
        setExternalVisible: setFilterFiledOpened,
        analyticCheckboxCallback: filterSelectedAnalyticsClick,
        analyticButtonCallback: cuisineAnalyticsButtonClick,
        resetAndSubmitFilters: resetAndSubmitFilters,
        withMapModalView: withMapModalView
      }));
    }
    return null;
  })))), !withMapModalView ? /*#__PURE__*/React.createElement("div", {
    className: "col-6 col-lg-3 col-xl-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filters__sort"
  }, /*#__PURE__*/React.createElement(Sorting, {
    values: sortField,
    deskLabelText: sortFieldDeskLabelText,
    mobileLabelText: sortFieldMobileLabelText,
    defaultSortValue: '',
    value: sortingValue,
    setSort: function setSort(newValue) {
      setSortingValue(newValue);
    },
    clearText: clearText,
    setListingFilter: setListingFilter,
    eventsAnalytics: eventsAnalytics,
    params: params
  }))) : null)), !withMapModalView ? /*#__PURE__*/React.createElement(FiltersSelected, {
    filterState: filterState,
    setFilter: function setFilter(newValue) {
      setFilterState(_objectSpread(_objectSpread({}, filterState), newValue));
    },
    resetFilters: function resetFilters(newValue) {
      setFilterState(newValue);
    },
    clearText: clearAllText,
    setListingFilter: setListingFilter,
    facets: facets,
    resetAndSubmitFilters: resetAndSubmitFilters,
    analyticsClick: removeFilterAnalyticsClick
  }) : null, searchTextValue && nbHits ? /*#__PURE__*/React.createElement("p", {
    className: "searchResultCounter",
    dangerouslySetInnerHTML: {
      __html: getFilteredResultText(filteredResultsText, nbHits, searchTextValue)
    }
  }) : null))));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(headerStyle, "   ").concat(commonStyleModalFilterValue, " ").concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles, "   ").concat(rtl ? rtlStylesModalFiltersValue : '')
  }, children);
};
export default Filter;
var commonStyles = "cc56l1y";
var ltrStyles = "l49mu5h";
var rtlStyles = "rmdqj96";
var commonStyleModalFilterValue = "c1wwitsu";
var rtlStylesModalFiltersValue = "r18ovil";